/**
 * PATH: apps/qa/src/pages/records-list/openJobQaInHub.ts
 * FILE_ID: QA-RECORDS-OPEN-JOB-QA-001
 * PURPOSE: Return an existing inspection id, or '' when the job has no QA.
 * WHY: The inspection editor lives at /records/:id. The QA bundle only
 *      rebuilds when this app changes, so this file stays in the build scope.
 */
import api from '@/lib/api'

export function jobQaHubPath(jobNumber: string): string {
  return `/records/job/${encodeURIComponent(jobNumber)}`
}

/** The QA hub inspection editor. Same door the dashboard recent list should use. */
export function qaRecordPath(inspectionId: string): string {
  return `/records/${encodeURIComponent(inspectionId)}`
}

function serverMessage(err: unknown, fallback: string): string {
  const data = (err as { response?: { data?: unknown } })?.response?.data
  if (data && typeof data === 'object') {
    const body = data as { error?: unknown; detail?: unknown }
    if (typeof body.error === 'string' && body.error.trim()) return body.error
    if (typeof body.detail === 'string' && body.detail.trim()) return body.detail
  }
  return fallback
}

export async function openJobQaInHub(jobNumber: string): Promise<string> {
  try {
    const created = await api().post('/qa/inspections/ensure-general/', { job_id: jobNumber })
    const body = created.data as { id?: unknown; inspection?: { id?: unknown } | null } | null
    const id = body?.id ?? body?.inspection?.id
    return id ? String(id) : ''
  } catch (err) {
    throw new Error(serverMessage(err, `Could not open QA for job ${jobNumber}.`))
  }
}
